import { render, staticRenderFns } from "./trainInfo.vue?vue&type=template&id=0b2911a2&scoped=true&"
import script from "./trainInfo.vue?vue&type=script&lang=js&"
export * from "./trainInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2911a2",
  null
  
)

export default component.exports